import { ProgramObject } from '@/types/epg/Program'
import { createModelSchema, optional, primitive, serialize } from 'serializr'
import { getNumericWeekDay } from '../helpers/dateHelpers'

class Program {
    id: string
    startMilis: number
    endMilis: number
    rating: string
    name: string
    shortDescription: string
    description: string
    durationMilis: number
    catchup?: number
    contentNumber?: string
    contentType?: string
    language?: string
    poster?: string
    numericWeekDay: number
    genre: string
    channelId?: string

    constructor(programProps: ProgramObject) {
        this.id = programProps.id
        this.startMilis = programProps.startMilis
        this.endMilis = programProps.endMilis
        this.rating = programProps.rating
        this.name = programProps.name
        this.shortDescription = programProps.shortDescription
        this.description = programProps.description
        this.durationMilis = programProps.durationMilis
        this.catchup = programProps.catchup
        this.contentNumber = programProps.contentNumber
        this.contentType = programProps.contentType
        this.language = programProps.language
        this.poster = programProps.poster
        this.numericWeekDay = getNumericWeekDay(this.startMilis)
        this.channelId = programProps.channelId
        this.genre =
            (Array.isArray(programProps.genre) &&
                programProps.genre.join(',')) ||
            String(programProps.genre) ||
            this.getGenre()
    }

    getGenre = (): string => {
        switch (this.contentType) {
            case '1':
                switch (this.contentNumber) {
                    case '4':
                        return 'genreComedy'
                    case '0':
                        return 'genreDrama'
                    default:
                        return 'genreMovies'
                }
            case '2':
                return 'genreNews'
            case '3':
                return 'genreEntertainment'
            case '4':
                return 'genreSport'
            case '5':
                return 'genreFamilyKids'
            case '6':
                return 'genreMusic'
            case '7':
                return 'genreArts'
            case '8':
                return 'genreLifestyle'
            case '9':
                switch (this.contentNumber) {
                    case '1':
                        return 'genreAnimalWildlife'
                    case '2':
                        return 'genreTechScience'
                    default:
                        return 'genreEducation'
                }
            case '10':
                switch (this.contentNumber) {
                    case '6':
                        return 'genreShopping'
                    case '1':
                        return 'GenreTravel'
                    default:
                        return 'GenreLifestyle'
                }
            default:
                return 'GenreOther'
        }
    }

    static serialize(program: Program): string {
        // Use the Program schema to serialize
        return JSON.stringify(serialize(Program, program))
    }

    static deserialize(programJson: string): Program {
        const programObj = JSON.parse(programJson)
        // Use the Program schema to deserialize
        return new Program(programObj)
    }
}

createModelSchema(Program, {
    id: primitive(),
    startMilis: primitive(),
    endMilis: primitive(),
    rating: primitive(),
    name: primitive(),
    shortDescription: primitive(),
    description: primitive(),
    durationMilis: primitive(),
    catchup: optional(primitive()),
    contentNumber: optional(primitive()),
    contentType: optional(primitive()),
    language: optional(primitive()),
    poster: optional(primitive()),
    numericWeekDay: primitive(),
    genre: primitive(),
    channelId: optional(primitive()),
})

export default Program
